import { useTranslation } from 'react-i18next';

import { StyledOverlay } from './style';
import { ESdkEvents } from '../../../../contracts';
import { sendFEEvent } from '../../../../eventUtil';
import { mobileSDKUtils } from '../../../../utils/mobile-sdk-utils';

interface ScreenLockProps {
  header?: string;
  action: () => void;
  actionText: string;
  text?: string;
  isRedirect?: boolean;
}

const mobileSDKCheckoutStyle = mobileSDKUtils.getCheckoutStyle();

export function ScreenLock({ actionText, action, header, text, isRedirect }: ScreenLockProps) {
  const backgroundColor = mobileSDKCheckoutStyle.overlayBackgroundColor;
  return (
    <StyledOverlay backgroundColor={backgroundColor}>
      <h2>{header}</h2>
      <p>{text}</p>
      {isRedirect ? (
        <button
          className="redirect-button"
          style={{
            backgroundColor: 'white',
            color: 'black',
          }}
          onClick={action}
        >
          {actionText}
        </button>
      ) : (
        <button onClick={action}>{actionText}</button>
      )}
    </StyledOverlay>
  );
}

export function ErrorFallbackRender({ error, resetErrorBoundary }: any) {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const redirectUrl = localStorage.getItem('redirectUrl') || '';

  const handleClose = () => {
    sendFEEvent(ESdkEvents.CLOSE_CHECKOUT, {
      reason: 'Error during fetch checkout data',
    });
  };

  return (
    <ScreenLock
      header={t('somethingWentWrong')}
      action={() => {
        if (redirectUrl) {
          localStorage.removeItem('redirectUrl');
          window.location.href = redirectUrl;
        } else {
          resetErrorBoundary();
          handleClose();
        }
      }}
      text={error}
      actionText={t('returnToGame')}
      isRedirect={!!redirectUrl}
    />
  );
}
